module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/press-desktop@2x-0a16530ff3fa48bb13e9fc430691d02e.jpg";